<template>
  <div>
    <l-legend-external
      v-if="legend"
      :active="isVisible"
      :config="legendConfig"
    />
    <l-control-identify
      v-if="identify"
      :url-base="layer.identify.url"
      :type="layer.identify.type"
      :fields="layer.identify.fields"
      :active="isVisible"
    />
  </div>
</template>
<script>
import LMapLegendExternal from "@/components/map/LMapLegendExternal";
import LControlIdentify from "@/components/map/LControlIdentify";

export default {
  components: {
    "l-legend-external": LMapLegendExternal,
    "l-control-identify": LControlIdentify
  },
  props: {
    identify: {
      type: Boolean,
      default: false
    },
    layer: {
      type: Object,
      required: true
    },
    legend: {
      type: Boolean,
      required: false,
      default: false
    },
    legendOptions: {
      type: Object,
      required: false,
      default() {
        return {
          format: "image/png",
          transparent: true,
          type: "WMS"
        };
      }
    },
    loadOnInit: {
      type: Boolean,
      required: false,
      default: true
    },
    projection: {
      type: Object,
      required: false,
      default: () => {
        return {
          code: "EPSG:3857",
          proj4def:
            "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378137 +b=6378137 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
        };
      }
    },
    showInLayerSwitcher: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      groupedLayerSwitcher: this.$parent.groupedLayersControl,
      map: this.$parent.mapObj,
      isVisible: false,
      legendConfig: {
        url: this.layer.url,
        layerName: this.layer.wmsOptions.layers,
        options: this.legendOptions
      }
    };
  },
  computed: {
    ready() {
      return this.layer !== null;
    }
  },
  destroyed() {
    this.removeLayer();
  },
  mounted() {
    if (this.ready) {
      this.init();
    }
  },
  methods: {
    init() {
      this.loadWmsLayer();
    },
    loadWmsLayer() {
      this.wmsLayer = L.tileLayer.wms(this.layer.url, this.layer.wmsOptions);
      this.setLayerEvents();

      if (this.loadOnInit) {
        this.wmsLayer.addTo(this.map);
      }
      if (this.showInLayerSwitcher) {
        this.groupedLayerSwitcher.addOverlay(
          this.wmsLayer,
          this.layer.wmsOptions.alias,
          this.layer.group
        );
      }
    },
    setLayerEvents() {
      const self = this;
      this.wmsLayer.on("add", () => {
        self.isVisible = true;
      });
      this.wmsLayer.on("remove", () => {
        self.isVisible = false;
      });
    },
    removeLayer() {
      if (Object.keys(this.wmsLayer).length > 0) {
        this.map.removeLayer(this.wmsLayer);
      }
    }
  }
};
</script>
<style scoped></style>
